import benchmark from '../../demo/fixtures/w5/benchmark.json'
import copy from '../../demo/fixtures/w5/copy.json'
import { Icon } from '../../ui'
import type { IconName } from '../../ui'
import styles from './AutomationPage.module.css'

type SignalState = keyof typeof benchmark.signalState

export function BenchSignals() {
  return (
    <section className={styles.benchSignals} data-scope="bench-signals" lang="zh-CN">
      <div className={styles.sectionHeading}>
        <p>{copy.sections.benchSignals}</p>
        <span>{copy.sections.benchSignalsHint}</span>
      </div>
      {benchmark.signals.map((item) => {
        const tone = benchmark.signalState[item.state as SignalState]
        return (
          <div className={styles.signal} key={item.signal}>
            <span className={styles.signalIcon}><Icon name={item.icon as IconName} size={16} /></span>
            <p className={styles.signalText}>{item.signal}</p>
            <p className={styles.signalAction}>
              <strong>→</strong> {item.action}
              <span className={`${styles.statusChip} ${styles[`${tone}Chip`]}`}>{item.label}</span>
            </p>
          </div>
        )
      })}
      <p className={styles.source}>
        <Icon name="globe" size={14} />
        {benchmark.source}
      </p>
    </section>
  )
}
